export default "__VITE_ASSET__BtrmGZtp__"